<template>
  <main>
    <section>
      <h4>Introdução</h4>
      <p class="text-justify">
        Um universo de tema medieval, composto por um mundo selvagem, com
        diversas montanhas, ilhas, pântanos, cavernas, extensas florestas, etc.
        A magia é abundante nesse universo e muitos seres conseguem a manipular.
        Esse universo possui dois planos de existência:
      </p>

      <h5 class="mt-4">Plano Material</h5>
      <p class="text-justify">
        O plano comum que é habitado por Humanos e Elfos.
      </p>

      <h5 class="mt-4">Plano Divino</h5>
      <p class="text-justify">
        O plano onde vivem seres divinos como Anjos, Demônios e Divindades.
      </p>
    </section>
    <hr />

    <section>
      <h4>História Principal</h4>
      <p class="text-justify">
        Há 1500 anos atrás, os portões entre os dois planos foram selados, pois
        os seres divinos estavam utilizando o
        <strong>Plano Material</strong> como campo de batalha, então guerreiros
        e magos de diversas nações se uniram para selar todos os portões,
        cortando a conexão dos planos.
      </p>

      <p class="text-justify">
        Depois do selo, o mundo viveu em paz por alguns séculos, até que o mundo
        se dividiu em dois grandes impérios: O
        <strong>Império de Zorel</strong> que dominava grande parte do norte e o
        <strong>Império de Oop</strong> que dominava grande parte do sul. A luta
        por poder e dominância não parecia ter fim e ambos os lados possuiam
        exércitos muito poderosos, fazendo com que a guerra continuasse através
        dos séculos.
      </p>

      <p class="text-justify">
        Há poucos anos atrás um elfo chamado <strong>Lyiot</strong>, que era um
        soldado comum do <strong>Império de Oop</strong> estava caminhando entre
        as <strong>Montanhas da Penumbra</strong>, local onde se encontra um dos
        pórtais selados e para sua surpresa viu um ser divino ali. Era o
        primeiro ser divino a aparecer em mais de um milênio. Esse ser era um
        Demônio da raça <strong>Succubus</strong> que por sua beleza, o encantou
        de imediato. O nome dela era <strong>Eve</strong> e ele a manteve em
        segredo, indo encontrar com ela por diversas vezes nas montanhas.
        <strong>Eve</strong> prometeu a ele o poder demoníaco, se ele
        concordasse em a ajudar a desfazer os selos dos portões.
        <strong>Lyiot</strong> estava completamente apaixonado por ela e aceitou
        prontamente.
      </p>

      <p class="text-justify">
        Com os novos poderes, <strong>Lyiot</strong> tomou o controle do
        <strong>Império de Oop</strong> e juntamente com
        <strong>Eve</strong> começaram o plano para abrir os portões. Ao ver
        essa situação, o <strong>Império de Zorel</strong> se viu obrigado a
        agir contra. O grande general do império, <strong>Azaan</strong> enviou
        <strong>Firyali</strong>, a melhor espiã de suas tropas, para investigar
        <strong>Lyiot</strong> de perto e reunir mais informações sobre
        <strong>Eve</strong>, enquanto ele comandava as tropas de defesa dos
        portões.
      </p>
    </section>
    <hr />

    <characters-list :universe="universe" />
  </main>
</template>

<script>
import CharactersList from '../CharactersList'

export default {
  name: 'beleza-das-trevas',

  props: {
    universe: { type: Object, required: true },
  },

  components: { CharactersList },
}
</script>
